import httpService from "./httpService";

export default {
  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get("/hcCaseDieuXe/findByHcCaseMaster", {params: params});
  },

  findById(id) {
    return httpService.get(`/hcCaseDieuXe/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/hcCaseDieuXeService.js